// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"201ae1e2","453":"6f89cfeb","455":"60e142fc","977":"18cfdae6"}[chunkId] + ".chunk.js";
};